import { z } from 'zod';
import { LABEL_COLORS, CLIENT_STAGES, STATUS_CATEGORIES } from '../domain';
import { fileDto } from './files';

/** Demanda vista pelo cliente: sem responsáveis, valores, prazos internos ou comentários internos. */
export const portalTaskDto = z.object({
  id: z.uuid(),
  title: z.string(),
  project: z.object({ id: z.uuid(), name: z.string() }).nullable(),
  /** Para o cliente, o nome é o da etapa do quadro (nunca o nome interno do workflow). */
  status: z.object({ name: z.string(), category: z.enum(STATUS_CATEGORIES), color: z.string() }),
  stage: z.enum(CLIENT_STAGES).nullable(),
  clientDueAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type PortalTaskDto = z.infer<typeof portalTaskDto>;

export const portalHomeDto = z.object({
  client: z
    .object({ id: z.uuid(), name: z.string(), color: z.enum(LABEL_COLORS), logoUrl: z.string().nullable() })
    .nullable(),
  tasks: z.array(portalTaskDto),
  deliveries: z.array(fileDto.extend({ projectName: z.string().nullable() })),
});
export type PortalHomeDto = z.infer<typeof portalHomeDto>;
